import type { SalesPole } from './poles'

export interface ProductGroup {
  visible: boolean
  keys: string[]
}

export interface GroupedProducts {
  main: string[]
  secondary: string[]
  leads: string[]
}

const MAIN_GROUPS = ['mainVA', 'mainLead']
const SECONDARY_GROUPS = ['secondaryVA', 'secondaryLead', 'others']

const keysOf = (groupConfig: Record<string, ProductGroup>, groups: string[]): string[] =>
  groups.flatMap(group => groupConfig[group]?.keys ?? [])

const byPole = (available: string[], pole: SalesPole) => {
  const inPole = (keys: string[]) => keys.filter(key => available.includes(key))

  return { main: inPole(pole.main), secondary: inPole(pole.secondary), leads: inPole(pole.leads) }
}

export const groupProducts = (
  groupConfig: Record<string, ProductGroup>,
  searchValue: string,
  titleOf: (key: string) => string,
  pole: SalesPole | null = null,
): GroupedProducts => {
  const search = searchValue.trim().toLowerCase()
  const matches = (key: string) => !search || titleOf(key).toLowerCase().includes(search)
  const main = keysOf(groupConfig, MAIN_GROUPS)
  const secondary = keysOf(groupConfig, SECONDARY_GROUPS)
  const grouped = pole ? byPole([...main, ...secondary], pole) : { main, secondary, leads: [] }

  return {
    main: grouped.main.filter(matches),
    secondary: grouped.secondary.filter(matches),
    leads: grouped.leads.filter(matches),
  }
}
